<template>
  <div class="container p-t-10 p-b-10 switchery-position">
    <p class="m-0 text-right">
      {{ statusText }}
      <span class="switchery switchery-small" :class="statusDisturb" @click.prevent="turnOffDisturb">
        <small></small>
      </span>
    </p>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters, mapActions } from 'vuex'
  import { NOT_DISTURB_STATUS } from '@/store/modules/auth'

  export default {
    name: 'DisturbStatus',
    watch: {
      $route (to, from) {
        if(from.name == "NotDisturbMode" && this.notDisturbStatus == NOT_DISTURB_STATUS.middle){
          this.setNotDisturbStatus(NOT_DISTURB_STATUS.off)
        }
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser',
        notDisturbStatus: 'auth/notDisturbStatus'
      }),
      notDisturbDate() {
        return this.$options.filters.formatDate(this.currentUser.not_disturb_until)
      },
      statusDisturb() {
        let status = this.notDisturbDate ? NOT_DISTURB_STATUS.on : this.notDisturbStatus
        return `switchery-${status}`
      },
      statusText() {
        let activatedText = this.$i18n.t('DisturbStatus.actived_not_disturb', { date: this.notDisturbDate })
        return this.notDisturbDate ? activatedText : this.$i18n.t('DisturbStatus.active_not_disturb')
      }
    },
    methods: {
      ...mapActions({
        setNotDisturbStatus: 'auth/setNotDisturbStatus',
        activeNotDisturb: 'users/activeNotDisturb'
      }),
      turnOffDisturb() {
        if (this.notDisturbDate) {
          this.activeNotDisturb('')
          .then(response => {
            if(response.status == 201) {
              this.setNotDisturbStatus(NOT_DISTURB_STATUS.off)
              this.$router.push({ name: 'Dashboard' })
            }
          })
        } else {
          this.setNotDisturbStatus(NOT_DISTURB_STATUS.middle)
          this.$router.push({ name: 'NotDisturbMode' })
        }
      }
    }
  }
</script>

<style scoped>
  .switchery-position {
    margin-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/DisturbStatus.vue